<template>
  <b-slider size="is-medium"
            :min="0"
            :max="100"
            :disabled="disabled"
            v-model="value"
            @change="handleValueChanged"
            @dragend="handleDragEnd"
  >
    <div v-if="presets && presets.length > 0">
      <template v-for="preset in presets">
        <b-slider-tick :value="preset.value" :key="preset.value" />
      </template>
    </div>
  </b-slider>
</template>

<script>
  import BSlider from "buefy/src/components/slider/Slider";
  import BSliderTick from "buefy/src/components/slider/SliderTick";

  export default {
    components: {
      BSliderTick,
      BSlider
    },
    name: "control-slider",
    props: ['propValue', 'disabled', 'presets', 'onChange'],
    data() {
      return {
        value: 0,
        numDrags: 0,
        numChanges: 0
      };
    },
    watch: {
      propValue(value) {
        this.value = parseFloat(value);
      }
    },
    computed: {},
    methods: {
      handleValueChanged(newValue) {
        this.numChanges++;
        if (typeof this.onChange === "function") {
          this.onChange(parseFloat(newValue));
        }
      },
      handleDragEnd() {
        this.numDrags++;
        if (this.numDrags === 1 && this.value === 0 && this.numChanges === 0) {
          this.handleValueChanged(this.value);
        }
      }
    },
    mounted() {
      this.numDrags = 0;
      this.numChanges = 0;
      if (this.propValue !== null) {
        this.value = parseFloat(this.propValue);
      }
    }
  }
</script>

<style scoped>

</style>